import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { usePassOnActions, usePassOns } from '../hooks/useFirestore';
import { useFileUpload } from '../hooks/useStorage';
import PassOnForm from '../components/PassOnForm';
import authService from '../services/authService';
import { validatePassOnData } from '../utils/validation';
import '../styles/PassOn.css';

const PassOn = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuth();
  const { createPassOn } = usePassOnActions();
  const { uploadFile } = useFileUpload();
  const { passOns } = usePassOns({ isActive: true, limit: 1 });
  const navigate = useNavigate();
  
  // Get the latest pass-on to show as context
  const latestPassOn = passOns.length > 0 ? passOns[0] : null;

  const handlePassOn = async (passOnData) => {
    try {
      setIsLoading(true);

      // Validate the pass-on data
      const validation = validatePassOnData({
        title: passOnData.name, // Using name as title for compatibility
        description: passOnData.text,
        category: 'other' // Default category
      });

      if (!validation.isValid) {
        alert(Object.values(validation.errors).join(', '));
        return;
      }


      // Auto sign-in anonymously if not authenticated
      if (!user) {
        try {
          await authService.signInAnonymously();
        } catch (authError) {
          console.error('Auto sign-in failed:', authError);
        }
      }

      // Create the pass-on first
      const passOnId = await createPassOn({
        title: passOnData.name,
        description: passOnData.text,
        category: 'other',
        gifUrl: passOnData.imageUrl || null,
        tags: []
      });

      // Upload image file if provided
      if (passOnData.imageFile) {
        try {
          await uploadFile(passOnData.imageFile, 'passOn', passOnId);
        } catch (uploadError) {
          console.error('File upload failed:', uploadError);
          // Continue without image if upload fails
        }
      }

      // Navigate immediately after creating pass-on
      navigate('/', { 
        state: { 
          message: 'Your reply has been posted successfully!' 
        } 
      });

    } catch (error) {
      console.error('Error creating pass-on:', error);
      alert(error.message || 'Something went wrong. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <div className="pass-on-page">
      <div className="pass-on-container">
        <header className="pass-on-header">
          <div className="pass-on-title-row">
            <a href="/" className="back-link">
              ← Back to Home
            </a>
            <h1>Reply</h1>
          </div>
          <p className="pass-on-description">
            Reply to the previous message with your thoughts, images, or GIFs
          </p>
        </header>

        <main className="pass-on-main">
          <PassOnForm 
            onPassOn={handlePassOn}
            isLoading={isLoading}
            previousPassOn={latestPassOn}
          />
        </main>
      </div>

    </div>
  );
};

export default PassOn;